// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetUpcomingEvents from './js/widgets/cardWidgetUpcomingEvents.js';
import cardWidgetSEOText from './js/widgets/cardWidgetSEOText.js';
import cardWidgetImageCards from './js/widgets/cardWidgetImageCards.js';
import cardWidgetEmailSignup from './js/widgets/cardWidgetEmailSignup.js';
import {facebookfeed, twitterfeed} from './js/widgets/socialNetworkWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import cssSponsors from './js/widgets/cssSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();   
    cardWidgetUpcomingEvents();
    cardWidgetSEOText();
    cardWidgetImageCards();
    cardWidgetEmailSignup();
  });
  
  $(window).load(function() {
    facebookfeed(true);
    twitterfeed();
    videoWidget();
    cssSponsors()
  });
}